export default "__VITE_ASSET__d80cb310__"